import Constants from 'expo-constants';

const env = Constants.manifest?.extra?.env || 'stg';

export default env === 'prod' ? require(`../config.prod.json`) : require(`../config.stg.json`);
